module.exports = __webpack_public_path__ + "img/scan-outline-grey.27be7bb3.svg";